import _ from 'underscore';
import { getImageUrl, getEntityUrl } from '../cultureUtils';

const ogTypesHash = {
	institutes: {
		musicalGroup: 'article',
		default: 'place'
	},
	movies: 'video.movie',
	broadcast: 'video.movie',
	persons: 'profile',
	books: 'books.book',
	objects: {
		rh: 'place',
		onkn: 'article',
		default: 'article'
	},
	tags: 'tag',
	default: 'article'
};

const entityOgMetas = (options) => {
	const basePath = options.config.basePath || '';
	const ogMetas = {
		url: options.config.baseUrl,
		type: ogTypesHash[options.entityType] || ogTypesHash.default
	};

	if (options.meta.og.thumbnailFile) {
		ogMetas.image = getImageUrl(options.meta.og.thumbnailFile, {
			type: 'image',
			dontUsePort: true
		});
	}

	if (_(['institutes', 'objects']).contains(options.entityType)) {
		if (options.entity.type && ogMetas.type[options.entity.type]) {
			ogMetas.type = ogMetas.type[options.entity.type];
		} else {
			ogMetas.type = ogMetas.type.default;
		}
	}

	ogMetas.url +=
		basePath + getEntityUrl(options.entityType, options.entity, options);

	return ogMetas;
};

export const getOgMetas = (options) => {
	let ogMetas = {};
	const defaultOgParams = {
		type: 'website',
		image: `${options.config.baseUrl}/images/logo-og-v2.png`,
		imageWidth: 1600,
		imageHeight: 800
	};

	if (options.entity) {
		ogMetas = _(entityOgMetas(options)).extend(
			_(options.meta.og).pick('title', 'description')
		);
	} else {
		let url = options.config.baseUrl;

		if (options.url) {
			url += options.url;
		} else if (options.rubric && options.rubric.path !== 'main') {
			url += `/${options.rubric.path}`;
		}

		ogMetas = _(defaultOgParams).extend(
			{ url },
			_(options.meta || options.rubric.meta.og).pick('title', 'description')
		);
	}

	ogMetas.siteName = 'Культура.РФ';

	return ogMetas;
};
